export function geraSurpresinha(tipoJogo) {

    var strReturn = ''//numAposta ? numAposta : '';

    var index = 0, num = "";
    var lstNumerosSorteados = []
    var lstCopy = []
    var intNumeroMin = tipoJogo.tnyNumeroMin;
    var intNumeroMax = tipoJogo.tnyNumeroMax;    
    var intTamanhoMin = tipoJogo.tnyTamanhoMin;
    var intQtdRepPermitidas = tipoJogo.tnyQtdRepPermitidas + 1;
    var intUnidade = tipoJogo.tnyUnidade;

    for (var i = intNumeroMin; i <= intNumeroMax; i++)
    {
        lstCopy.push(i);
    }    

    //Gera o número surpresa removendo os números quando a quantidade de repetições for atingida
    while (strReturn.length < intTamanhoMin)
    {
        index = getRandomInt(0, lstCopy.length-1);

        num = `${lstCopy[index]}`.padStart(intUnidade, '0')        
        lstNumerosSorteados.push(num);

        var qtdOcorrencias = 0;

        for(var i = 0; i < lstNumerosSorteados.length; i++)
        {
            if (lstNumerosSorteados[i] == num && ++qtdOcorrencias >= intQtdRepPermitidas)
            {
                lstCopy.splice(index, 1); 
            }
        }

        strReturn = lstNumerosSorteados.join('');
    }
    //}

    strReturn = formataNumeroApostaSeparador(strReturn, tipoJogo)
    return strReturn;
    
}


function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function formataNumeroApostaSeparador(strNumero, tipoJogo){

    //return strNumero;

    var apostaRetorno = strNumero;
    var removeUltimo = true;

    if(!tipoJogo){
        tipoJogo = {chrSeparador: 'x'}
    }

    if (tipoJogo.chrSeparador.trim().length > 0)
    {
        strNumero = strNumero.split(tipoJogo.chrSeparador.trim()).join('')
        apostaRetorno = "";
        var tnyUnidade = tipoJogo.tnyUnidade;
        if (tnyUnidade > 0)
        {
            var aposta = "";
            for (var i = 0; i < strNumero.length; i = i + tnyUnidade)
            {
                if(i + tnyUnidade <= strNumero.length) {
                    aposta = strNumero.substring(i, i + tnyUnidade);
                    apostaRetorno += aposta + tipoJogo.chrSeparador;

                }else{
                    apostaRetorno += strNumero.substring(i, i + 1);
                    removeUltimo = false;
                }
            }

            if(removeUltimo)
                apostaRetorno = apostaRetorno.substring(0, apostaRetorno.length - 1);
        }
    }
    return apostaRetorno;

}

export function limpaApostaNumeroSeparador(strNumero, tipoJogo){

    strNumero = strNumero.split(tipoJogo.chrSeparador.trim()).join('')
    return  strNumero
       
}


// WEBPACK FOOTER //
// ./src/loteria/utils/apostaUtils.js